import React, { useRef } from 'react';
import PropTypes from "prop-types"

import * as formstyles from "../styles/forms.module.css"
import { Button } from 'semantic-ui-react';


const FileBrowser = ({textlabel, className, handleFile, multiple, disabled}) => {

	const fileinput = useRef(null);

	return(
		<>
			<Button 
				type="button"
				disabled={disabled}
				className={className}
				onClick={(e)=>{fileinput.current.click()}}
				icon="upload"
				content={textlabel.length > 0 && <span>{textlabel}</span>}
			/>
			<input
				disabled={disabled}
				type="file"
				ref={fileinput}
				onChange={handleFile}
				style={{display: 'none'}}
				multiple={multiple}
			/>
		</>
	)
}


FileBrowser.propTypes = {
	textlabel: PropTypes.string,
	className: PropTypes.string,
	multiple: PropTypes.bool,
	disabled: PropTypes.bool,
}


FileBrowser.defaultProps = {
	textlabel: '',
	className: formstyles.iconbutton,
	multiple: false,
	disabled: false
}


export default FileBrowser;

